<template>
  <div id="location">
    <BaseArchiveTemplate>
      <template v-if="isLocationParent" #sub-nav>
        <div class="discover-heading">
          Discover our content through location
        </div>
      </template>
      <template v-else #sub-nav>
        <BaseFilterButton v-b-toggle="locationsListCollapse"
                          :location="true"
                          :state="locationsListCollapseIsShown"
                          :collapse-id="locationsListCollapse" />
        <BaseRouteDropdown v-if="!isLocationParent" :routes="locationFilters" />
        <div class="selected-location">
          <span>from</span>{{ $route.params.id }}
        </div>
      </template>
    </BaseArchiveTemplate>
    <router-view />
  </div>
</template>

<script>
import BaseFilterButton from "@/components/ui/BaseFilterButton";
import configRoutes from '../router/configRoutes';
import BaseArchiveTemplate from "@/components/BaseArchiveTemplate";
import BaseRouteDropdown from "@/components/ui/BaseRouteDropdown";
export default {
  name: "Location",
  components: {
    BaseArchiveTemplate,
    BaseFilterButton,
    BaseRouteDropdown
  },
  beforeRouteUpdate(to, from, next) {
    const routeHasNoQuery = Object.keys(to.query).length === 0 && Object.keys(from.query).length === 0;
    // Close locations list dropdown
    if (this.locationsListCollapseIsShown && routeHasNoQuery) {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit('bv::toggle::collapse', this.locationsListCollapse);
    }
    setTimeout(()=>{
      next();
    },200);
  },
  beforeRouteLeave(to, from, next) {
    if (this.locationsListCollapseIsShown) {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit('bv::toggle::collapse', this.locationsListCollapse);
    }
    next();
  },
  data: () => ({
    routes: configRoutes.locationRoutes,
    locationFilters: configRoutes.locationFilters,
    locationsListCollapse: 'location-index-collapse',
    locationsListCollapseIsShown: false
  }),
  computed: {
    isLocationParent() {
      return this.$route.name === 'discover-location';
    }
  },
  activated() {
    this.openLocationList();
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === this.locationsListCollapse) {
          this.locationsListCollapseIsShown = isJustShown;
      }
    });
  },
  methods: {
    openLocationList() {
      if(!this.locationsListCollapseIsShown && this.$route.name === 'discover-location') {
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$root.$emit('bv::toggle::collapse', this.locationsListCollapse);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";
.selected-location {
  @include font-18-md;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  @include media-breakpoint-down(md) {
    @include font-14-md;
    margin-right: auto;
  }
  span {
    font-family: "Times New Roman", serif;
    font-style: italic;
    text-transform: lowercase;
    margin-right: 10px;
    margin-left: 5px;
    margin-bottom: 2px;
  }
}
</style>
